module.exports = __webpack_public_path__ + "static/media/3.06b457cf.jpg";